import styled, { css } from 'styled-components';
import { FooterContent } from '../FooterContent';
import { Header } from './Header';
import { useThemeMode } from '../../theme';

const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-width: 100%;
    min-height: 100vh; /* fallback for older browsers */
    min-height: 100dvh;
    margin: 0;
    background: ${theme.paper.default};
  `
);

const Main = styled.main`
  height: 100%;
  width: 100%;
  min-height: min-content;
  margin: 0;
  padding: 1rem;
  display: flex;
  gap: 1rem;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;

  @media (max-width: 630px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
`;

const Footer = styled.footer<{ $light: boolean }>(
  ({ $light, theme }) => css`
    background: ${theme.paper.default};
    min-height: 5rem;
    width: 100%;
    border-top: ${$light ? '3px' : '1px'} solid ${theme.border.default};
    color: ${theme.text.default};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    padding-top: calc(0.5rem - ${$light ? '2px' : '0px'});
  `
);

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  const { mode } = useThemeMode();
  const light = mode === 'light';

  return (
    <Content>
      <Header />
      <Main>{children}</Main>
      <Footer $light={light}>
        <FooterContent />
      </Footer>
    </Content>
  );
}
